import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/**
 * 获取厂家列表
 * @param params
 */
export const getFactoryList = (params:object = {}) => $http.get('/cake_api/manufacturersList', params)
/**
 * 获取分类列表
 * @param params
 */
export const getCatsList = (params:object = {}) => $http.get('/cake_api/catList', params)

/**
 * 获取品牌列表
 * @param params
 */
export const saveCouponRefund = (data: object) => $http.post('/cake_api/dgssRefund', data)

/**
 * 获取作废券列表
 * @param params
 */
export const getCancelledCouponListApi = (params: object) => $http.get('/cake/couponRefundList', params)

/**
 * 优惠券退款
 * user_coupon_id，此字段为单张券退款时必填
 */
export const saveCouponRefundApi = (data: object) => $http.post('/cake_api/dgssRefund', data)

/**
 * 更新已作废券状态
 * coupon_no: 券码
 * type: 1-继续售卖，2-真作废
 */
export const updateCancelledCouponStatusApi = (id: number, type: number) => $http.post('/cake/couponRefundSave', { id, type })


export const getBrandListApi = (params:object = {}) => $http.get('/cake_api/brandList', params)
/**
 * 获取渠道列表
 * @param params
 */
export const getChannelListApi = (params:object = {}) => $http.get('/cake_api/channel_list', params)
/**
 * 获取渠道列表
 * @param params
 */
export const getSaasChannelListApi = (params:object = {}) => $http.get('/goods/getChannelList', params)
/**
 * 根据品牌ID获取商品列表
 * @param params
 */
export const getProductListByBrandApi = (brand_ids:string = '') => $http.get('/cake_api/productDataList', { brand_ids })
/**
 * 获取指定渠道限制数据
 * @param params
 */
export const getChannelLimitInfoApi = (channel_id:any) => $http.get('/cake_api/controlShow', { channel_id })
/**
 * 检查渠道是否支持屏蔽/开放
 * @param params
 */
export const getLimitAccessApi = (channels_ids:string, type:number) => $http.get('/cake_api/checkoutControl', { channels_ids, type })
/**
 * 保存屏蔽/开放
 * @param params
 */
export const saveLimitApi = (data:any) => $http.get('/cake_api/closeProduct', data)

/**
 * 获取门店列表
 * @param params
 */
export const getShopListApi = (params: object = {}) => $http.get('/coupon/shop/shop_get_data', params)

/**
 * 获取门店详情
 * @param params
 */
export const getShopDetailApi = (id: string) => $http.get('/cake_api/shop/get_saas_shop_info', { id })

/**
 * 保存门店信息
 * @param params
 */
export const saveShopApi = (data: object) => $http.post('/coupon/shop/shop_data_save', data)
